import React from 'react'

import InteractiveTagsList from 'components/tags/InteractiveTagsList'

import type { TagResponse } from 'types/entities/shared'
import type { TagGroupType } from 'types/modules/tags'

type Props = {
  group: TagGroupType
  tags?: TagResponse[TagGroupType]
}

const TagGroupChips: React.FC<Props> = ({ group, tags }) => {
  if (!tags?.length) return null

  return (
    <InteractiveTagsList
      isViewOnly
      data={{ tagDetails: { [group]: tags } }}
      disableAccount={group !== 'forAccount'}
      disableLocation={group !== 'forLocation'}
      disableService={group !== 'forService'}
    />
  )
}

export default TagGroupChips
